module.exports = __webpack_public_path__ + "img/apps-reports.80f6bda9.png";